import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../../../base/constant";

export interface VirtualTourItem {
    id?: number | string;
    project_name: string;
    bhk_type: string;
    tour_link: string;
    is_selected?: boolean;
}

export interface VirtualTourResponse {
    result: {
        status: boolean;
        message: string;
        data: {
            matched_tour: VirtualTourItem | null;
            variants: VirtualTourItem[];
            project_name?: string;
            bhk?: string;
            has_tour: boolean;
        };
    };
}

// Complete static tour database extracted from 360 View Links.xlsx
export const FALLBACK_360_TOURS: { project: string; bhk: string; link: string }[] = [
    { project: "Mercury", bhk: "3 BHK", link: "https://gkstudios.in/360/Mercury/3BHK" },
    { project: "Mercury", bhk: "4 BHK", link: "https://gkstudios.in/360/Mercury/4BHK" },
    { project: "Mercury", bhk: "4 BHK Villa", link: "https://gkstudios.in/360/Mercury/Villa/" },
    { project: "Zodiac", bhk: "2 BHK", link: "https://kuula.co/share/collection/7MnwM?logo=1&info=1&fs=1&vr=0&zoom=1&thumbs=1" },
    { project: "Zodiac", bhk: "3 BHK", link: "https://kuula.co/share/collection/7Mnwz?logo=1&info=1&fs=1&vr=0&zoom=1&thumbs=1" },
    { project: "Aquagrove", bhk: "2 BHK", link: "https://kuula.co/share/collection/7Mr8j?logo=0&info=1&fs=1&vr=0&sd=1&thumbs=1" },
    { project: "Aquagrove", bhk: "3 BHK", link: "https://kuula.co/share/collection/7Mr82?logo=1&info=1&fs=1&vr=0&zoom=1&thumbs=1" },
    { project: "Elysium", bhk: "2 BHK", link: "https://www.casagrand.co.in/360/new-360/vitural-tour/cg-elysium/" },
    { project: "Majestica", bhk: "2 BHK", link: "https://gkstudios.in/Majestica/2BHK/" },
    { project: "Majestica", bhk: "3 BHK", link: "https://gkstudios.in/Majestica/3BHK/" },
    { project: "Majestica", bhk: "Exterior View", link: "https://casagrand.co.in/360/majestica/exterior/" },
    { project: "Ventra", bhk: "Aerial View", link: "https://gkstudios.in/360/Ventra" },
    { project: "Osaka", bhk: "3 BHK", link: "https://my.matterport.com/show/?m=U6AB4xYQEhN" },
    { project: "Osaka", bhk: "Exterior View", link: "https://pixaer.in/virtualtour/osaka/" },
    { project: "Massimo", bhk: "2 BHK", link: "https://www.casagrand.co.in/360/new-360/vitural-tour/2-bhk" },
    { project: "Massimo", bhk: "3 BHK", link: "https://www.casagrand.co.in/360/new-360/vitural-tour/3-bhk/" },
    { project: "Aria", bhk: "2 BHK", link: "https://www.casagrand.co.in/360/new-360/vitural-tour/aria-tour" },
    { project: "Madelyn", bhk: "2 BHK", link: "https://kuula.co/share/collection/7bSwL?logo=1&card=1&info=0&logosize=85&fs=1&vr=0&zoom=1&sd=1&initload=0&autorotate=0.22&autop=25&thumbs=1&alpha=0.77" },
    { project: "Madelyn", bhk: "3 BHK", link: "https://kuula.co/share/collection/7bSws?logo=1&card=1&info=0&logosize=85&fs=1&vr=0&zoom=1&sd=1&initload=0&autorotate=0.22&autop=25&thumbs=1&alpha=0.77" },
    { project: "Highcity", bhk: "2 BHK", link: "https://my.matterport.com/show/?m=xAxqkw8Dpu6" },
    { project: "Highcity", bhk: "3 BHK - 2T", link: "https://my.matterport.com/show/?m=XPBr1WpFs7A" },
    { project: "Highcity", bhk: "3 BHK", link: "https://my.matterport.com/show/?m=wD5mP43XmKy" },
    { project: "Casamia", bhk: "2 BHK", link: "https://kuula.co/share/collection/7bQCJ?logo=1&card=1&info=0&logosize=104&fs=1&vr=1&zoom=1&sd=1&initload=0&autorotate=0.16&autop=20&thumbs=1&margin=7&alpha=0.70" },
    { project: "Casamia", bhk: "3 BHK", link: "https://kuula.co/share/collection/7bQTC?logo=1&card=1&info=0&logosize=104&fs=1&vr=1&zoom=1&sd=1&initload=0&autorotate=0.16&autop=20&thumbs=1&margin=7&alpha=0.70" },
    { project: "Reva", bhk: "3 BHK", link: "https://kuula.co/share/collection/71Yxc?logo=1&info=1&fs=1&vr=0&zoom=1&thumbs=1" },
    { project: "Reva", bhk: "3 BHK - 3T", link: "https://kuula.co/share/collection/71Yr7?logo=1&info=1&fs=1&vr=0&zoom=1&thumbs=1" },
    { project: "Reva", bhk: "Exterior View", link: "https://gkstudios.in/360/RevaExt" },
    { project: "Flagship", bhk: "3 BHK", link: "https://www.casagrand.co.in/360/new-360/vitural-tour/tour/" },
    { project: "Flagship", bhk: "4 BHK", link: "https://www.casagrand.co.in/360/new-360/vitural-tour/4bhk-tour/" },
    { project: "Cloud9", bhk: "Interior and Exterior", link: "https://www.casagrand.co.in/360/Cloud9/" },
    { project: "Hola Chennai", bhk: "2 BHK", link: "https://my.matterport.com/show/?m=M9Ru48berUX" },
    { project: "Hola Chennai", bhk: "3 BHK", link: "https://my.matterport.com/show/?m=wWfbrJb7VkA" },
    { project: "Hola Chennai", bhk: "4 BHK", link: "https://my.matterport.com/show/?m=ySt4zggKUfE" },
    { project: "Hola Chennai", bhk: "Exterior View", link: "https://www.casagrand.co.in/360/Hola-Chennai/3D/" },
    { project: "Hola Chennai", bhk: "Aerial View", link: "https://www.casagrand.co.in/360/Hola-Chennai/AREAL-VIEW/" },
    { project: "Elinor", bhk: "3 BHK", link: "https://www.casagrand.co.in/360/new-360/vitural-tour/elinor-tour" },
    { project: "Jarvis", bhk: "3 BHK", link: "https://kuula.co/share/hXmMV/collection/717mF?logo=1&card=1&info=0&logosize=85&fs=1&vr=0&sd=1&initload=0&autorotate=0.18&autop=25&thumbs=1&alpha=0.60" },
    { project: "Southbrooke", bhk: "2 BHK", link: "https://www.casagrand.co.in/360/new-360/vitural-tour/sbtour" },
    { project: "Estoria", bhk: "1 BHK", link: "https://my.matterport.com/show/?m=zJFnsf85vwJ" },
    { project: "Estoria", bhk: "2 BHK", link: "https://my.matterport.com/show/?m=jzKNapB7uuX" },
    { project: "Suncity", bhk: "2 BHK", link: "https://www.casagrand.co.in/360/Suncity/2BHK/" },
    { project: "Suncity", bhk: "3 BHK", link: "https://www.casagrand.co.in/360/Suncity/3BHK/" },
    { project: "Suncity", bhk: "4 BHK", link: "https://www.casagrand.co.in/360/Suncity/4BHK/" },
    { project: "Suncity", bhk: "Aerial View", link: "https://kuula.co/share/collection/7dp4q?logo=1&info=1&fs=1&vr=0&sd=1&autop=10&thumbs=1&margin=7&alpha=0.79" },
    { project: "Casablanca", bhk: "2 BHK", link: "https://kuula.co/share/collection/7cRry?logo=-1&info=0&fs=1&vr=0&zoom=1&gyro=0&initload=0&autorotate=0.08&thumbs=1" },
    { project: "Casablanca", bhk: "3 BHK", link: "https://kuula.co/share/collection/7cRr4?logo=-1&info=0&fs=1&vr=0&zoom=1&gyro=0&initload=0&autorotate=0.06&thumbs=1" },
    { project: "Promenade", bhk: "3 BHK", link: "https://onetobeam.com/virtual_tours/Casagrand_Promenade/" },
    { project: "Estancia", bhk: "3 BHK", link: "https://kuula.co/share/collection/7DzSh?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1" },
    { project: "Moondance", bhk: "3 BHK", link: "https://onetobeam.com/virtual_tours/CASAGRAND_MOONLAND/" },
    { project: "Amor", bhk: "2 BHK", link: "https://onetobeam.com/virtual_tours/Casagrand_Amor/2BHK/" },
    { project: "Amor", bhk: "3 BHK", link: "https://onetobeam.com/virtual_tours/Casagrand_Amor/3BHK/" },
    { project: "Orchards Villa", bhk: "3 BHK", link: "https://gkstudios.in/360/Orchards/" },
    { project: "Highlin", bhk: "3 BHK", link: "https://gkstudios.in/360/Highline/" },
    { project: "Belair", bhk: "4 BHK", link: "https://viz.spaceviz.ai/mhxp-dev/Casagrand_Pudur.mhx/199/index.html" },
    { project: "Crestwood", bhk: "4 BHK", link: "https://www.casagrand.co.in/360/pudur/?v=1.211010" },
    { project: "Monaco Villa", bhk: "4 BHK", link: "https://www.casagrand.co.in/360/monaco-villa/" },
    { project: "Mandarin", bhk: "4 BHK", link: "https://digilogy25.viewin360.co/share/collection/7ML1Z?logo=-1&info=0&fs=1&vr=1&zoom=1&sd=1&gyro=0&initload=0&thumbs=0" },
    { project: "Dior", bhk: "3 BHK", link: "https://storage.net-fs.com/hosting/7861251/3/" },
    { project: "Dior", bhk: "4 BHK", link: "https://storage.net-fs.com/hosting/7861251/1/" },
    { project: "Aspires", bhk: "3 BHK", link: "https://www.casagrand.co.in/360/new-360/vitural-tour/aspire-final" }
];

export const normalizeString = (str?: string): string => {
    if (!str) return "";
    return str.toLowerCase().replace(/casagrand/gi, "").replace(/[^a-z0-9]/g, "");
};

export const findLocal360Tour = (projectName?: string, bhkType?: string) => {
    if (!projectName) return { matched_tour: null, variants: [], has_tour: false };

    const normProj = normalizeString(projectName);
    const matchedVariants = FALLBACK_360_TOURS.filter(item => {
        const itemNorm = normalizeString(item.project);
        return itemNorm && normProj && (itemNorm === normProj || itemNorm.includes(normProj) || normProj.includes(itemNorm));
    });

    if (matchedVariants.length === 0) {
        return { matched_tour: null, variants: [], has_tour: false };
    }

    // Match BHK
    const normBhk = (bhkType || "").toLowerCase();
    let bestMatch = matchedVariants[0];

    // Priority matching
    for (const v of matchedVariants) {
        const vBhk = v.bhk.toLowerCase();
        if (normBhk.includes("villa") && vBhk.includes("villa")) {
            bestMatch = v;
            break;
        }
        const digitMatch = normBhk.match(/([1-5])\s*bhk/);
        if (digitMatch && vBhk.includes(`${digitMatch[1]} bhk`)) {
            bestMatch = v;
            break;
        }
        if (normBhk && vBhk.includes(normBhk)) {
            bestMatch = v;
            break;
        }
    }

    const variants: VirtualTourItem[] = matchedVariants.map((v, idx) => ({
        id: idx + 1,
        project_name: v.project,
        bhk_type: v.bhk,
        tour_link: v.link,
        is_selected: v.link === bestMatch.link
    }));

    return {
        matched_tour: {
            id: 1,
            project_name: bestMatch.project,
            bhk_type: bestMatch.bhk,
            tour_link: bestMatch.link,
        },
        variants,
        has_tour: true
    };
};

export const virtualTourApi = createApi({
    reducerPath: "virtualTourApi",
    baseQuery: fetchBaseQuery({
        baseUrl: config().BASE_URL,
    }),
    endpoints: (builder) => ({
        get360Tour: builder.query<VirtualTourResponse, { project_name?: string; bhk?: string; property_type?: string }>({
            query: ({ project_name, bhk, property_type }) => {
                const params = new URLSearchParams();
                if (project_name) params.append("project_name", project_name);
                if (bhk || property_type) params.append("bhk", (bhk || property_type) as string);
                return `/project-360-tour/?${params.toString()}`;
            },
        }),
    }),
});

export const { useGet360TourQuery } = virtualTourApi;
